/**
 * テーマ設定 themeCartAddedFeedback に応じて /cart/add.js の sections と成功時 UI を切り替える。
 * - mini_cart: ミニカート用 sections（従来）
 * - cart_notification: Dawn 系 cart-notification 用 sections
 */
(function () {
  function mode() {
    return window.themeCartAddedFeedback || 'mini_cart';
  }

  window.themeSectionsForCartAdd = function () {
    return mode() === 'cart_notification'
      ? 'cart-notification-product,cart-notification-button,cart-icon-bubble'
      : 'mini-cart-body,mini-cart-footer,info-cart';
  };

  /**
   * @param {object} data - /cart/add.js の JSON
   * @returns {boolean} true ならミニカート側の更新は不要
   */
  window.themeHandleCartAddJsonResponse = function (data) {
    if (!data || data.status === 422) return false;
    if (mode() !== 'cart_notification') return false;
    var el = document.querySelector('cart-notification');
    if (!el || !data.sections) return false;
    if (!data.key && data.items && data.items[0]) {
      data.key = data.items[0].key;
    }
    if (!data.key) return false;
    if (typeof window.themeDismissModalPresentation === 'function') {
      window.themeDismissModalPresentation();
    } else {
      document.body.classList.remove('is-presenting-modal');
      document.body.classList.remove('pdp-custom-options-open');
      if (typeof window.pdpCloseCustomOptionsOverlay === 'function') {
        window.pdpCloseCustomOptionsOverlay();
      }
      var mc = document.getElementById('modal-container');
      if (mc) mc.innerHTML = '';
    }
    try {
      el.renderContents(data);
    } catch (e) {
      console.error(e);
      return false;
    }
    var btn = document.querySelector('#cart-button');
    if (btn) btn.classList.add('cart-button--has-item');
    return true;
  };
})();
